module.exports = __webpack_public_path__ + "img/dhl.d94d842b.jpg";